var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layoutWrapper",style:(("height: " + _vm.viewHeight))},[_c('div',{staticClass:"content",class:_vm.contentClass},[_vm._t("default")],2),_c('Nav')],1)}
var staticRenderFns = []

export { render, staticRenderFns }